import { Payment } from "./InvoicePaymentData";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

export const InvoicePaymentDataGetInvoicePaymentsQuery: AgTechQuery<number, Payment[]> = {
    queryKey: (invoiceId: number) => ['Payments', invoiceId],
    query: async (props) => {
        return await props.http.getEntity({
            request: `Invoice/${props.inputData}/Payments`
        });
    },
    content: {
        loadingText: 'Loading invoice payments...',
        failureText: 'Failed to load invoice payments.'
    }
}